import { Spin } from "antd";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { PATHS } from "../../../app/router/paths";
import { useAuth } from "../model/AuthContext";

export const ProtectedRoute = () => {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div
        style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (status === "anonymous") {
    return (
      <Navigate to={PATHS.AUTH.LOGIN} replace state={{ from: location }} />
    );
  }

  return <Outlet />;
};
